import { EnvironmentProviders } from '@angular/core';
import { authInitializerProvider } from './auth.provider';
import { iconInitializerProvider } from '@app/utils/providers/icon.provider';
import { googleTagManagerInitializerProvider } from '@app/utils/providers/google-tag-manager.provider';
import { loadingScreenInitializerProvider } from '@app/utils/providers/loading-screen.provider';

export const appInitializer: EnvironmentProviders[] = [
  authInitializerProvider,
  iconInitializerProvider,
  googleTagManagerInitializerProvider,
  loadingScreenInitializerProvider,
];
